// @flow

import type { HierarchyState } from "./types";

export const initialState: HierarchyState = {
  requestsInProgress: 0,
  active: null,
  myActive: null,
};

export default initialState;
